import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _availability = {
    start: 'google.protobuf.Timestamp',
    end: 'google.protobuf.Timestamp',
    locations: '_location',
};
var _batchCreateResourceRequest = {
    resources: '_resource',
    batchedResources: '_createResourceRequest',
};
var _batchCreateResourceResponse = { resources: '_resource' };
var _batchDeleteResourceRequest = {};
var _batchDeleteResourceResponse = {};
var _batchRequest = {
    createRequests: '_createScheduleRequest',
    updateRequests: '_updateScheduleRequest',
    cancelRequests: '_cancelScheduleRequest',
};
var _batchResponse = {
    created: '_schedule',
    updated: '_schedule',
    cancelled: '_schedule',
};
var _cancelScheduleRequest = { from: 'google.protobuf.Timestamp' };
var _createResourceRequest = {
    resource: '_resource',
    schedules: '_schedule',
};
var _createResourceResponse = { resource: '_resource' };
var _createScheduleRequest = { schedule: '_schedule' };
var _deleteResourceRequest = {};
var _deleteResourceResponse = {};
var _getBusinessResourceRequest = {};
var _getBusinessResourceResponse = { resource: '_resource' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _linkResourceToUserRequest = {};
var _linkResourceToUserResponse = { resource: '_resource' };
var _listResourcesRequest = {};
var _listResourcesResponse = { resources: '_resource' };
var _location = {
    customAddress: '_address',
    businessLocation: '_locationsLocation',
};
var _locationsAddress = { geocode: '_locationsAddressLocation' };
var _locationsAddressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _locationsLocation = { address: '_locationsAddress' };
var _queryResourcesRequest = {};
var _queryResourcesResponse = { resources: '_resource' };
var _recurringInterval = {
    start: 'google.protobuf.Timestamp',
    end: 'google.protobuf.Timestamp',
};
var _resource = {
    images: '_image',
    schedules: '_schedule',
    eventsSchedule: '_schedule',
};
var _resourceUpdateScheduleRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    schedule: '_schedule',
};
var _schedule = {
    firstSessionStart: 'google.protobuf.Timestamp',
    lastSessionEnd: 'google.protobuf.Timestamp',
    created: 'google.protobuf.Timestamp',
    updated: 'google.protobuf.Timestamp',
    intervals: '_recurringInterval',
    location: '_location',
    availability: '_availability',
};
var _unLinkResourceFromOwnerRequest = {};
var _unLinkResourceFromOwnerResponse = { resource: '_resource' };
var _updateResourceRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    resource: '_resource',
    scheduleActions: '_batchRequest',
};
var _updateResourceResponse = {
    resource: '_resource',
    schedules: '_batchResponse',
};
var _updateScheduleRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    schedule: '_schedule',
};
var _updateScheduleResponse = { schedule: '_schedule' };
function resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/resources-server',
                destPath: '',
            },
        ],
        'bookings._base_domain_': [
            {
                srcPath: '/_api/resources-server',
                destPath: '',
            },
            {
                srcPath: '/internal/resources-server',
                destPath: '/internal',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/resources-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/resources-server',
                destPath: '',
            },
        ],
        _base_domain_: [
            {
                srcPath: '/_api/resources-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/resources-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/resources',
                destPath: '/v1/resources',
            },
            {
                srcPath: '/_api/bookings/v1/resources/staff',
                destPath: '/v1/staff',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/resources-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/resources',
                destPath: '/v1/resources',
            },
            {
                srcPath: '/_api/bookings/v1/resources/staff',
                destPath: '/v1/staff',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/resources',
                destPath: '/v1/resources',
            },
            {
                srcPath: '/_api/bookings/v1/resources',
                destPath: '/v1/resources',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/resources',
                destPath: '/v1/resources',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/resources',
                destPath: '/v1/resources',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings/v1/resources',
                destPath: '/v1/resources',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with [Query Resource](https://dev.wix.com/api/rest/wix-bookings/resources/list-resources/query-resource) and will be removed on March 31, 2022.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Retrieves a list of the resources according to the provided filters and paging.
 * Resources that are in a resource group (i.e. the group_id property contains an ID) are excluded from the result for backwards compatibility.
 * <!--ONLY:REST-->
 * This query is optional. If no query is provided than all non-deleted resources are returned.
 *
 * |Property|Is supported|
 * |--|--|
 * |filter | supports `resource.id`, `resource.tag`, `resource.status`|
 * |paging | supported |
 * |fields | supported |
 * |fieldsets | **not supported** |
 * |sort| **not supported** |
 *
 * > **Permissions**
 * > This endpoint requires the Read Bookings Calendar, Read Bookings - Public Data, Read Bookings - Including Participants or Manage Bookings permission scope.
 * <!--END:ONLY:REST-->
 */
export function list(payload) {
    var _a = serializer(_listResourcesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listResourcesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.List',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({ protoPath: '/v1/resources', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
/**
 * Retrieves a list of the resources according to the specified filters and paging.
 *
 * The query parameter is optional. If no query is provided then all non-deleted resources are returned.
 * Resources that are in a resource group (i.e. the group_id property contains an ID) are excluded from the result for backwards compatibility unless the `include_resources_with_groups` request field is set to true.
 *
 * |Property|Is supported|
 * |--|--|
 * |filter | supported fields: `resource.id`, `resource.tags`, `resource.status`|
 * |paging | supported |
 * |fields | supported |
 * |fieldsets | **not supported**  |
 * |sort | **not supported**  |
 *
 *
 * >**Notes:**
 * > + The following objects in the `query` parameter are not supported for this query:
 * >    - `sort`
 * >    - `fieldsets`
 *
 * > **Permissions**
 * > This endpoint requires the Read Bookings Calendar, Read Bookings - Public Data, Read Bookings - Including Participants or Manage Bookings permission scope.
 */
export function query(payload) {
    var _a = serializer(_queryResourcesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryResourcesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }).fromJSON;
    function __query(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.Query',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({ protoPath: '/v1/resources/query', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __query.fromReq = fromReq;
    __query.__isAmbassador = true;
    return __query;
}
/**
 * Returns the Business Resource.
 *
 * This endpoint is only implemented in the Resources V2 proxy.
 * When called for a site that is not rolled out to V2 an error is returned.
 */
export function getBusinessResource(payload) {
    var _a = serializer(_getBusinessResourceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBusinessResourceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }).fromJSON;
    function __getBusinessResource(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.GetBusinessResource',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({ protoPath: '/v1/resources/business', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBusinessResource.fromReq = fromReq;
    __getBusinessResource.__isAmbassador = true;
    return __getBusinessResource;
}
/**
 * Creates a resource.
 * <!--ONLY:VELO
 * The `createResource()` function returns a Promise that resolves to the created resource.
 * <!--END:ONLY:VELO-->
 *
 * Bookings resources are created with a schedule. The schedule and its sessions determine the resource's availability. Note that the schedule must contain a start date in the `availability.start` property.
 * For resources that are available during the business's default hours, add the business's schedule as a linked schedule in the resource's schedule. For resources that have their own hours, create sessions with type `"WORKING_HOURS"` using the resource's schedule.
 * You can use both individual and recurring sessions to define resource availability. You cannot use availability constraints for resource schedules.
 *
 * <!--ONLY:VELO
 * When creating a resource using `createResource()`, include the resource's schedule information. Set the schedule information as follows:
 * + If the resource uses the default business hours, get the business resource's schedule ID  and include it in the `scheduleInfo.availability.linkedSchedules` array in the `scheduleInfo` parameter. The default hours can bee found in the Dashboard under **Settings** in the **Bookings** section, on the **Appointment hours** page.
 * + If the resource has its own custom working hours, create the resource, then create sessions of type `"WORKING_HOURS"` using the [`createSession()`](wix-bookings-backend.Sessions/createsession) function. Use the `scheduleId` returned from `createResource()` when creating the sessions. These session can be single sessions or recurring sessions.
 * + You can have both default business hours and custom hours for the same resource schedule by combining the steps above.
 *
 * > **Notes:**
 * > + The Wix Bookings app does not show both default business hours and custom hours on the **Staff** page in the dashboard. If you've set up both custom and default business hours, only the default business hours will appear in the app, although both are working.
 * > + The Wix Bookings app does not show non-recurring `WORKING_HOURS` sessions in the resource calendar.
 * > + You can only add the business resource's schedule as a linked schedule for a resource.
 * > + A resource can have one schedule only.
 * > + You can have up to 135 active resources and an additional 135 deleted resources.
 * > + Only users with the **Bookings Admin** [role](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin) can create a resource. You can override the role permissions by setting the `options.suppressAuth` parameter to `true`.
 * <!--END:ONLY:VELO-->
 *
 * <!--ONLY:REST-->
 * Use the following steps to create resources:
 * - Create the resource using including schedule information.
 * - If the resource uses the default business hours, get the business resource's schedule ID  and include it in the `scheduleInfo.availability.linkedSchedules` array in the in the schedule parameters.
 * - If the resource has its own custom working hours, create sessions of type `"WORKING_HOURS"`. Use the `scheduleId` of the new resource when creating the sessions. These session can be single sessions or recurring sessions. You can have both business hours and custom hours for the same resource schedule.
 *
 * >**Notes:**
 * > + A resource can have one schedule only.
 * > + You can have up to 135 active resources and an additional 135 deleted resources.
 * > + The `businessLocation.businessSchedule` object in the `schedule.location` object is not supported.
 *
 *
 *
 * >**Permissions:**
 * > This endpoint requires the Manage Bookings [permission scope](https://devforum.wix.com/kb/en/article/available-permissions).
 * <!--END:ONLY:REST-->
 */
export function create(payload) {
    var _a = serializer(_createResourceRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createResourceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }).fromJSON;
    function __create(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.Create',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({ protoPath: '/v1/resources', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __create.fromReq = fromReq;
    __create.__isAmbassador = true;
    return __create;
}
/** Creates multiple resources with corresponding schedules. */
export function batchCreate(payload) {
    var _a = serializer(_batchCreateResourceRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _createResourceRequest: _createResourceRequest,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_batchCreateResourceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }).fromJSON;
    function __batchCreate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.BatchCreate',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({ protoPath: '/v1/resources/batch', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __batchCreate.fromReq = fromReq;
    __batchCreate.__isAmbassador = true;
    return __batchCreate;
}
/**
 * Updates a resource.
 * <!--ONLY:VELO
 * The `updateResource()` function returns a Promise that resolves when a resource is updated.
 * Use this function to update all bookings resource information except for the resource's schedule. To update a resource's schedule use [`updateResourceSchedule()`](wix-bookings-backend/resource/updateresourceschedule).
 *
 * >**Notes:**
 * > + When updating a resource you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the values `"business"` and `"staff"`.
 * > + Only users with the **Bookings Admin** [role](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin) can update a resource. You can override the role permissions by setting the `options.suppressAuth` parameter to `true`.
 * <!--END:ONLY:VELO-->
 * <!--ONLY:REST-->
 * Use this endpoint to update all resource information except for the resource's schedule. To update a resource's schedule use
 * the [Update Schedule](https://dev.wix.com/api/rest/wix-bookings/resources/update-schedule) endpoint.
 *
 * >**Notes:**
 * > + When updating a resource you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the values `"business"` and `"staff"`.
 * > + When updating a resource's schedule you cannot change the resource tag used by the Wix Bookings app. Tags used by the app have the values `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE”`.
 * > + The `businessLocation.businessSchedule` object in the `schedule.location` object is not supported.
 *
 * >**Permissions:**
 * > This endpoint requires the Manage Bookings [permission scope](https://devforum.wix.com/kb/en/article/available-permissions).
 * <!--END:ONLY:REST-->
 */
export function update(payload) {
    var _a = serializer(_updateResourceRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _batchRequest: _batchRequest,
        _cancelScheduleRequest: _cancelScheduleRequest,
        _createScheduleRequest: _createScheduleRequest,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
        _updateScheduleRequest: _updateScheduleRequest,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateResourceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _batchResponse: _batchResponse,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'PATCH',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.Update',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({ protoPath: '/v1/resources/{resource.id}', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/**
 * Updates a resource's schedule
 * <!--ONLY:VELO
 * The `updateResourceSchedule()` function returns a Promise that resolves when a resource's schedule has been updated.
 * Use this function to update the bookings resource's schedule. To update other resource details  use [`updateResource()`]  (wix-bookings-backend/resources/updateresource).
 * The following schedule properties can be updated:
 * + `availability.start`
 * + `availability.linkedSchedules`
 * <!--END:ONLY:VELO-->
 *
 * To update a resource's schedule to remove business hours and add custom hours:
 * <!--ONLY:REST-->
 * + Update the resource's schedule to remove the business's `scheduleId` from the `availability.linkedSchedules` array.
 * + Create a set of recurring sessions of type `"WORKING_HOURS"` to define the resource's new hours.
 * <!--END:ONLY:REST-->
 * <!--ONLY:VELO
 * + Use [`updateResourceSchedule()`](wix-bookings-backend.Resources/updateresourcesession) to remove the business's scheduleId from the   `availability.linkedSchedules` array.
 * + Use [`createSession()`](wix-bookings-backend.Sessions/createsession) to create a set of recurring sessions of type `"WORKING_HOURS"` to   define the resource's new hours.
 * <!--END:ONLY:VELO-->
 *
 * To update a resource's schedule to add default business hours, and keep or remove custom hours:
 * <!--ONLY:REST-->
 * + Update the resource's schedule to add the business resource's `scheduleId` to the `availability.linkedSchedules` array.
 * + If you want to remove the custom sessions, delete the resource's sessions of type `"WORKING_HOURS"`.
 * You do not have to delete exiting custom sessions. Custom session that are not deleted will continue to be included in availability  calculations and can still be booked.
 * <!--END:ONLY:REST-->
 * <!--ONLY:VELO
 * + Use [`updateResourceSchedule()`](wix-bookings-backend.Resources/updateresourcesession) to add the business resource's `scheduleId` to   the `availability.linkedSchedules` array.
 * + If you want to remove the custom sessions, use [`deleteSession()`](wix-bookings-backend.Sessions/deletesession) to delete the   resource's sessions of type `"WORKING_HOURS"`. You do not have to delete exiting custom sessions. You can have both default working hours   and custom hours for the same schedule. Custom sessions that are not deleted will continue to be included in availability calculations  and can still be booked.
 *
 * > **Notes:**
 * > + The Wix Bookings app does not show both default business hours and custom hours on the **Staff** page in the dashboard. If you've set   up both custom and default business hours, only the default business hours will appear in the app, although both are working.
 * > + A resource can have one schedule only.
 * > + A resource can have both default business hours and custom hours in its schedule.
 * > + When updating a resource's schedule you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the   values `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE”`.
 * > + Only users with the **Bookings Admin** [role](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin) can   update a resource schedule. You can override the role permissions by setting the `options.suppressAuth` parameter to `true`.
 * @snippet [updateResourceScheduleDefaultToCustom.es6=Update a resource's schedule from business to custom hours]
 * Update a resource's schedule from the business's default working hours to 2 custom days per week.
 * @snippet [updateResourceScheduleCustomToDefault.es6=Update a resource's schedule from custom to business hours]
 * <!--END:ONLY:VELO-->
 * <!--ONLY:REST-->
 * >**Notes:**
 * > + A resource can have one schedule only.
 * > + A resource can have both default business hours and custom hours in its schedule.
 * > + When updating a resource's schedule you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the   values `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE”`.
 * > + The `businessLocation.businessSchedule` object in the `schedule.location` object is not supported.
 *
 *
 *
 * >**Permissions:**
 * > This endpoint requires the Manage Bookings [permission scope](https://devforum.wix.com/kb/en/article/available-permissions).
 * <!--END:ONLY:REST-->
 */
export function updateSchedule(payload) {
    var _a = serializer(_resourceUpdateScheduleRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateScheduleResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _schedule: _schedule,
    }).fromJSON;
    function __updateSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'PATCH',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.UpdateSchedule',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({
                protoPath: '/v1/resources/{resourceId}/updateSchedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSchedule.fromReq = fromReq;
    __updateSchedule.__isAmbassador = true;
    return __updateSchedule;
}
/**
 * Deletes a resource.
 * <!--ONLY:VELO
 * The `deleteResource()` function returns a Promise that is resolved when a resource is deleted.
 * <!--END:ONLY:VELO-->
 * Deleting a resource updates its `status` to `"DELETED"`.
 *
 * You cannot delete a resource if it has booked sessions.
 *
 * <!--ONLY:VELO
 * >**Notes:**
 * > + The Bookings app automatically creates a resource with a name and tag of value `"business"``. This resource is used for the business's schedule and working hours and cannot be deleted.
 * > + You can have up to 135 active resources and an additional 135 deleted resources.
 * > + Only users with the **Bookings Admin** [role](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin) can delete a resource. You can override the role permissions by setting the `options.suppressAuth` parameter to `true`.
 * <!--END:ONLY:VELO-->
 *
 * <!--ONLY:REST-->
 * >**Notes:**
 * > + The Bookings app creates a resource with `"business"` in name and tag values. This resource is used for the business's schedule and working hours and cannot be deleted.
 * > + You can have up to 135 active resources and an additional 135 deleted resources.
 *
 * >**Permissions:**
 * > This endpoint requires the Manage Bookings [permission scope](https://devforum.wix.com/kb/en/article/available-permissions).
 * <!--END:ONLY:REST-->
 */
export function _delete(payload) {
    var _a = serializer(_deleteResourceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteResourceResponse, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'DELETE',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService._Delete',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({ protoPath: '/v1/resources/{id}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
export function batchDelete(payload) {
    var _a = serializer(_batchDeleteResourceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_batchDeleteResourceResponse, {}).fromJSON;
    function __batchDelete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'DELETE',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.BatchDelete',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({ protoPath: '/v1/resources', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __batchDelete.fromReq = fromReq;
    __batchDelete.__isAmbassador = true;
    return __batchDelete;
}
/**
 * Links a resource to a Wix user.
 * The user will be assigned with the `Bookings Staff Member` role, via the `SitePoliciesManagement.AssignPolicies` API.
 *
 * Preconditions:
 * - The resource must not be linked to a user, or an active invite.
 * - The user must be a site contributor
 * - The user must not be linked to another resource.
 *
 * Note:
 * The site owner may be linked to a resource, but will not be assigned with the 'Bookings Staff Member' role.
 */
export function linkResourceToUser(payload) {
    var _a = serializer(_linkResourceToUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_linkResourceToUserResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }).fromJSON;
    function __linkResourceToUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.LinkResourceToUser',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({
                protoPath: '/v1/resources/{resourceId}/link-to-user',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __linkResourceToUser.fromReq = fromReq;
    __linkResourceToUser.__isAmbassador = true;
    return __linkResourceToUser;
}
/** Unlink a resource from the site owner. */
export function unLinkResourceFromOwner(payload) {
    var _a = serializer(_unLinkResourceFromOwnerRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unLinkResourceFromOwnerResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availability: _availability,
        _image: _image,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _recurringInterval: _recurringInterval,
        _resource: _resource,
        _schedule: _schedule,
    }).fromJSON;
    function __unLinkResourceFromOwner(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.resource',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.resources.core.api.v1.resource.ResourcesService.UnLinkResourceFromOwner',
            url: resolveComWixpressBookingsResourcesCoreApiV1ResourceResourcesServiceUrl({
                protoPath: '/v1/resources/{resourceId}/unlink-from-owner',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unLinkResourceFromOwner.fromReq = fromReq;
    __unLinkResourceFromOwner.__isAmbassador = true;
    return __unLinkResourceFromOwner;
}
//# sourceMappingURL=http.impl.js.map